import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import {
    Dialog, FlatButton, Table, TableHeader, TableRow,
    TableHeaderColumn, TableBody, TableRowColumn, CircularProgress
} from "material-ui"
import { IHierarchyItem, IJobHierarchySettingsData } from "../../../models"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import AccountStore from "../../../stores/AccountStore"

interface IProps {
    settingPropertyName: string
    hierarchyId: string
    handleClose(): void
}
interface IState {
    loading: boolean
    hierarchyItems: IHierarchyItem[]
    jobs: IJobHierarchySettingsData[]
}

export default class HierarchyJobVariationsDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: AccountStore.getJobsEnabled(),
            hierarchyItems: [],
            jobs: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getHierarchyVariations()
        this.getJobVariations()
    }

    getHierarchyVariations() {
        this.setState({
            hierarchyItems: hierarchyHelper.getHierarchyVariations(this.props.hierarchyId, this.props.settingPropertyName)
        })
    }

    getJobVariations() {
        AccountStore.getJobsEnabled() &&
            api.getJobVariations(AccountStore.getCurrentAccount().Id, this.props.hierarchyId || "", this.props.settingPropertyName).then(res =>
                this.setState({
                    loading: false,
                    jobs: res.data
                })
            )
    }

    render() {
        return (
            <Dialog
                modal
                open
                autoScrollBodyContent
                title={strings.Hierarchy_Job_Variations}
                actions={[
                    <FlatButton
                        data-intercom-target={"HierarchySettings-Hierarchy-Job-Variations-Btn-Close"}
                        label={strings.Close}
                        secondary
                        keyboardFocused
                        onClick={this.props.handleClose}
                    />
                ]}
                onRequestClose={this.props.handleClose}
            >
                <div style={{ textAlign: "center" }}>
                    {this.state.loading ?
                        <CircularProgress /> :
                        this.state.hierarchyItems.length + this.state.jobs.length === 0 ?
                            strings.No_Hierarchy_Job_Variations :
                            <Table
                                multiSelectable={false}
                            >
                                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow>
                                        <TableHeaderColumn style={styles.columnHeader}>{strings.Name}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.HierarchyLevel}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.CostCenter}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.Parent_Hierarchy}</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody displayRowCheckbox={false}>
                                    {this.state.hierarchyItems.map(row =>
                                        <TableRow key={row.Id}>
                                            <TableRowColumn style={styles.columnValue}>{row.Label}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{hierarchyHelper.getHierarchyDefinitionNameByHierarchyDefinitionId(row.HierarchyDefinitionId)}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{row.CostCenter}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue} title={hierarchyHelper.getFullPathLabel(row.ParentId)}>{hierarchyHelper.getFullPathLabel(row.ParentId)}</TableRowColumn>
                                        </TableRow>
                                    )}
                                    {this.state.jobs.map(row =>
                                        <TableRow key={row.Id}>
                                            <TableRowColumn style={styles.columnValue}>{row.Name}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{strings.Job}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{row.CostCode}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue} title={hierarchyHelper.getFullPathLabel(row.HierarchyId)}>{hierarchyHelper.getFullPathLabel(row.HierarchyId)}</TableRowColumn>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                    }
                </div>
            </Dialog>
        )
    }
}

const styles = {
    columnValue: {
        textAlign: "left",
        cursor: "pointer"
    },
    columnHeader: {
        textAlign: "left"
    },
}